import React, { useState, useEffect } from "react";
import Moment from "react-moment";
import { useSelector, use } from "react-redux";
import { Link } from "react-router-dom";

import { SubTab } from "../Cms/TabNInput";
import useRequest from "../../hooks/useRequest";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import { API } from "../../constant/api";
import moment from "moment";
import { SlideshowLightbox, initLightboxJS } from "lightbox.js-react";
import "lightbox.js-react/dist/index.css";
import SendOffer from "./SendOffer";
import InvoiceOrder from "./InvoiceOrder";

const Activated = () => (
  <span className="label label-lg label-light-success label-inline">
    Activated
  </span>
);

const Deactivated = () => (
  <span className="label label-lg label-light-danger label-inline">
    Deactivated
  </span>
);
const statusArrayForInvoice = [
  "Order Confirmed",
  "Order Delivered",
  "Order Partially Returned",
  "Order Returned",
];
const ViewOne = (props) => {
  const { id } = props.match.params;

  const [tabMenu, setTabMenu] = useState([
    "Order Information",
    "Items",
    "Vendor Offers",
  ]);
  const [userData, setUserData] = useState([]);
  const [userDetails, setUserDetails] = useState([]);
  const [offerDetails, setOfferDetails] = useState([]);
  const [order, setOrder] = useState();
  const [offer, setOffer] = useState([]);
  const [orderOffer, setOrderOffer] = useState([]);
  const [isShowForm, setIsShowForm] = useState(false);

  const [tabIndex, setTabIndex] = useState(0);

  const { response: responseUserData, request: requestUserData } = useRequest();
  const { response: responseItemData, request: requestItemData } = useRequest();

  const { response: responseOfferData, request: requestOfferData } =
    useRequest();
  const { response: responseVendorOfferData, request: requestVendorOfferData } =
    useRequest();

  const { date_format, date_time_format } = useSelector(
    (state) => state.setting
  );

  useEffect(() => {
    requestUserData("GET", `orders/${id}`);

    document.title = "View Order - Easyspare";
  }, []);

  useEffect(() => {
    requestItemData("GET", `orders/item/${id}`);
  }, []);

  useEffect(() => {
    requestVendorOfferData("GET", `orders/offer/new/${id}`);
  }, [isShowForm]);

  useEffect(() => {
    setOrderOffer(responseVendorOfferData?.orderOffer);
  }, [responseVendorOfferData]);

  useEffect(() => {
    if (responseUserData) {
      const {
        requestId,
        brandName,
        customer,
        contact,
        modelName,
        year,
        sparePartsLength,
        vin,
        brandImage,
        status,
        createdAt,
      } = responseUserData.orders;
      if (statusArrayForInvoice.includes(status)) {
        let newData = [...tabMenu];

        let foundOrderInvoice = false; // Flag to check if "Order Invoice" already exists

        newData.forEach((item) => {
          if (item === "Order Invoice") {
            foundOrderInvoice = true;
          }
        });

        if (!foundOrderInvoice) {
          newData.push("Order Invoice");
        }
        setTabMenu(newData);
      }
      setUserData([
        { title: "Order Number", value: requestId },
        { title: "Brand Name", value: brandName },
        {
          title: "Brand Image",
          value:
            brandImage?.length > 0 ? (
              <div className="d-flex" style={{ gap: "20px" }}>
                <img data-fancybox src={`${brandImage}`} width="100px" alt="" />
              </div>
            ) : (
              <p>No pictures found !</p>
            ),
        },
        { title: "Customer Info", value: `${customer}` + " , " + `${contact}` },
        { title: "Model Name", value: modelName },
        { title: "Manufacture Year", value: year },
        {
          title: "Vin",
          value: vin,
        },
        {
          title: "Total Items",

          value: sparePartsLength,
        },
        {
          title: "Status",
          value: status,
        },

        {
          title: "CREATED ON",
          value: <Moment format={date_time_format}>{createdAt}</Moment>,
        },
      ]);
    }
  }, [responseUserData]);

  useEffect(() => {
    if (responseItemData) {
      setUserDetails(responseItemData?.orderOffer);
    }
  }, [responseItemData]);

  useEffect(() => {
    if (responseOfferData) {
      setOfferDetails(responseOfferData?.orderOffer);
      setOffer(responseOfferData?.order?.result);
      const { itemName, itemDescription } = responseOfferData?.order;
      setOrder([
        { title: "Name of Part", value: itemName },
        { title: "Description", value: itemDescription },
      ]);
    }
  }, [responseOfferData]);

  const currentTabIndexHandler = (idx) => {
    setTabIndex(idx);
  };
  const statusArray = [
    "Order Confirmed",
    "Order Canelled",
    "Order Delivered",
    "Order Returned",
    "Order Partially Returned",
  ];
  return (
    <div
      className="content  d-flex flex-column flex-column-fluid ere"
      id="kt_content"
    >
      <Breadcrumb
        title="View Order"
        links={[
          { to: "/", name: "Dashboard" },
          { to: "/orders", name: "Back To Orders" },
        ]}
      />
      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="card card-custom gutter-b">
            <div className="card-header card-header-tabs-line">
              <div className="card-toolbar">
                <ul
                  className="nav nav-tabs nav-tabs-space-lg nav-tabs-line nav-bold nav-tabs-line-3x"
                  role="tablist"
                >
                  {tabMenu?.map((data, index) => (
                    <SubTab
                      key={index}
                      name={data}
                      index={index}
                      onClick={currentTabIndexHandler}
                      currentIndex={tabIndex}
                    />
                  ))}
                </ul>
              </div>
            </div>
            {/* Tab 1 */}
            <div
              style={{
                display: tabIndex === 0 ? "block" : "none",
              }}
              className="card-body px-0"
            >
              <div className="tab-content px-10">
                <div
                  className={`tab-pane ${tabIndex === 0 ? "active" : ""}`}
                  id={`kt_apps_contacts_view_tab_0`}
                  role="tabpanel"
                >
                  {userData.length > 0 &&
                    userData.map((user, index) => (
                      <div key={index} className="form-group row my-2">
                        <label className="col-4 col-form-label">
                          {user.title}
                        </label>
                        <div className="col-8">
                          <span className="form-control-plaintext font-weight-bolder">
                            {/* {user.value} */}
                            <span
                              className={`label label-lg label-light-${
                                user.value === "Order Confirmed" ||
                                user.value === "Request Submitted" ||
                                user.value === "Order Delivered"
                                  ? "success"
                                  : user.value === "Offer Received"
                                  ? "warning"
                                  : user.value === "Order Returned" ||
                                    user.value === "Order Partially Returned" ||
                                    user.value === "Order Cancelled"
                                  ? "danger"
                                  : "white text-dark"
                              } label-inline`}
                            >
                              {user.value}
                            </span>
                          </span>
                        </div>
                      </div>
                    ))}

                  <div className="row"></div>
                </div>
              </div>
            </div>
            {/* Tab 2  */}
            <div
              style={{
                display: tabIndex === 1 ? "block" : "none",
              }}
              className="card-body px-0"
            >
              <div className="tab-content px-10">
                <div className="tab-content px-10">
                  <div
                    className={`tab-pane ${tabIndex === 1 ? "active" : ""}`}
                    id={`kt_apps_contacts_view_tab_1`}
                    role="tabpanel"
                  >
                    <div className="row">
                      <div
                        className="accordion1 accordion"
                        id="accordionExample1"
                      >
                        {userDetails.length > 0 &&
                          userDetails.map((item, index) => {
                            return (
                              <div
                                className="card mb-3"
                                style={{ width: "700px" }}
                              >
                                <div className="card-header" id="headingOne1">
                                  <button
                                    className="btn btn-link rowInBtn"
                                    type="button"
                                    data-toggle="collapse"
                                    data-target="#collapseOne1"
                                    aria-expanded="false"
                                    aria-controls="collapseOne1"
                                  >
                                    <span className="partsHead">
                                      <span>Name of Part{""}</span>
                                      {item?.spareParts?.name || "-"}
                                    </span>
                                    <span className="partsHead">
                                      <span>Part Number{""}</span>
                                      {item?.spareParts?.partNumber || "-"}
                                    </span>
                                  </button>
                                </div>
                                <div
                                  id="collapseOne1"
                                  className="show"
                                  aria-labelledby="headingOne1"
                                  data-parent="#accordionExample1"
                                >
                                  <div className="card-body">
                                    {/* <span>Name of Part: {""}</span>
                                    {item?.name}
                                    <br /> <br /> */}
                                    <div className="mb-4">
                                      <span className="partInfoLabel">
                                        Quantity: {""}
                                      </span>
                                      {item?.spareParts?.quantity || "-"}{" "}
                                    </div>
                                    <div className="mb-4">
                                      <span className="partInfoLabel">
                                        Description: {""}
                                      </span>
                                      {item?.spareParts?.description || "-"}{" "}
                                    </div>
                                    {/* <span>PartNumber: {""}</span>
                                    {item?.partNumber} <br /> <br /> */}

                                    <span className="partInfoLabel">
                                      Images: {""}
                                    </span>
                                    <div className="row">
                                      {item?.spareParts?.images && (
                                        <div className="partsImageCard grid grid-cols-3 gap-2 col-12">
                                          <SlideshowLightbox>
                                            {item.spareParts?.images?.map(
                                              (image, index) => (
                                                <img
                                                  key={index}
                                                  src={`${API.PORT}/${image}`}
                                                  alt="img"
                                                  className="p-5-"
                                                  style={{
                                                    width: "120px",
                                                    height: "90px",
                                                    cursor: "pointer",
                                                  }}
                                                />
                                              )
                                            )}
                                          </SlideshowLightbox>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Tab 3 */}
            <div
              style={{
                display: tabIndex === 2 ? "block" : "none",
              }}
              className="card-body px-0"
            >
              {console.log(
                "responseUserData?.orders?.status :",
                responseUserData?.orders?.status
              )}
              <div className="tab-content px-10">
                <div className="tab-content px-10 position-relative">
                  {!statusArray.includes(responseUserData?.orders?.status) ? (
                    <div className="position-absolute top-0 right-0">
                      {/* <Link to={`/orders/send-offer/${id}`}> */}
                      <button
                        className="btn btn-primary"
                        //  font-weight-bold  px-2 py-2 mb-10"
                        type="button"
                        onClick={() => setIsShowForm(!isShowForm)}
                      >
                        {isShowForm ? "Show Offer" : "Send Offer"}
                      </button>
                      {/* </Link> */}
                    </div>
                  ) : null}
                  <div
                    className={`tab-pane ${tabIndex === 2 ? "active" : ""}`}
                    id={`kt_apps_contacts_view_tab_1`}
                    role="tabpanel"
                  >
                    {/* <h5 className="mb-4 mt-5">Vendor Offers</h5> */}
                    {!isShowForm && (
                      <div className="row">
                        <div className="accordion" id="accordionExample">
                          <div className="card- " style={{ width: "700px" }}>
                            {orderOffer?.length > 0 &&
                              orderOffer.map((item, index) => {
                                const accordionId = `accordion-${index}`;
                                const collapseId = `collapse-${index}`;
                                return (
                                  <div className="card mb-3" key={index}>
                                    <div
                                      className="card-header"
                                      id={`heading-${index}`}
                                    >
                                      <button
                                        className="btn btn-link rowInBtn"
                                        type="button"
                                        data-toggle="collapse"
                                        data-target={`#${collapseId}`}
                                        aria-expanded="false"
                                        aria-controls={collapseId}
                                      >
                                        <span className="partsHead">
                                          <span>Name of Vendor{""}</span>
                                          {item.vendorsData?.firstName +
                                            " " +
                                            item.vendorsData?.lastName}
                                        </span>
                                        <span className="partsHead">
                                          <span>Email{""}</span>
                                          {item.vendorsData?.email || "N/A"}
                                        </span>
                                      </button>
                                    </div>
                                    <div
                                      id={collapseId}
                                      // className="collapse"
                                      aria-labelledby={`heading-${index}`}
                                      data-parent="#accordionExample"
                                      className="show"
                                    >
                                      <div className="card-body">
                                        {item.items.length > 0
                                          ? item.items.map((val, index) => (
                                              <div
                                                className="vendoritemList"
                                                key={
                                                  index +
                                                  "" +
                                                  val.sparePart?.partNumber
                                                }
                                              >
                                                <div className="mb-4">
                                                  <span className="partInfoLabel">
                                                    Name of Part:{" "}
                                                  </span>
                                                  {val.sparePart?.partName ||
                                                    "N/A"}
                                                </div>
                                                <div className="mb-4">
                                                  <span className="partInfoLabel">
                                                    Price:{" "}
                                                  </span>
                                                  {val.ordersOffersData
                                                    ?.price || 0}
                                                </div>

                                                <div className="mb-4">
                                                  <span className="partInfoLabel">
                                                    Is Part Available:{" "}
                                                  </span>
                                                  {val.ordersOffersData
                                                    ?.isPartAvailable
                                                    ? "YES"
                                                    : "NO"}{" "}
                                                </div>

                                                <div className="mb-4">
                                                  <span className="partInfoLabel">
                                                    Is Part Genuine:{" "}
                                                  </span>
                                                  {val.ordersOffersData
                                                    ?.isPartGenuine
                                                    ? "YES"
                                                    : "NO"}{" "}
                                                </div>
                                                <div className="mb-4">
                                                  <span className="partInfoLabel">
                                                    Description:{" "}
                                                  </span>
                                                  {val.sparePart?.description ||
                                                    "N/A"}
                                                </div>

                                                <div className="mb-4">
                                                  <span className="partInfoLabel">
                                                    Notes:{" "}
                                                  </span>
                                                  {val.ordersOffersData
                                                    ?.notes || "N/A"}
                                                </div>


                                                <div className="mb-4">
                                                  <span className="partInfoLabel">
                                                  Shipment Notes:{" "}
                                                  </span>
                                                  {val.ordersOffersData
                                                    ?.shipmentnotes || "N/A"}
                                                </div>

                                                

                                                <div className="mb-4">
                                                  <span className="partInfoLabel">
                                                    Images:{" "}
                                                  </span>
                                                  <div className="row">
                                                    {val.ordersOffersData
                                                      ?.images?.length > 0 ? (
                                                      <div className="partsImageCard grid grid-cols-3 gap-2 col-12">
                                                        <SlideshowLightbox>
                                                          {val.ordersOffersData?.images?.map(
                                                            (image, i) => {
                                                              return (
                                                                <img
                                                                  key={i}
                                                                  src={`${API.PORT}/${image}`}
                                                                  alt="img"
                                                                  className="p-5"
                                                                  style={{
                                                                    width:
                                                                      "120px",
                                                                    height:
                                                                      "90px",
                                                                    cursor:
                                                                      "pointer",
                                                                  }}
                                                                />
                                                              );
                                                            }
                                                          )}
                                                        </SlideshowLightbox>
                                                      </div>
                                                    ) : null}
                                                  </div>
                                                </div>
                                              </div>
                                            ))
                                          : null}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      </div>
                    )}
                    {isShowForm ? (
                      <SendOffer id={id} setTabIndex={setTabIndex} />
                    ) : null}
                  </div>

                  <div className="row"></div>
                </div>
              </div>
            </div>
            {/* Tab 4 */}
            {tabIndex === 3 ? <InvoiceOrder orderId={id} /> : null}
          </div>
        </div>
      </div>
    </div>
    // </div>
  );
};

export default ViewOne;
